import gql from 'graphql-tag'

export default gql`{
    project_expense_types{
        id
        description
        vat_percentage
    }
}`